
import React from 'react';
import './style.scss'
import PropTypes from 'prop-types';
import {
   MediaChip,
   MediaInfoChip,
   MediaButton,
   MediaLableItem,
   MediaMemberBottonOptions,
} from 'common/components/modules/media';
import Icon from 'common/components/elements/icons';
import TruncateText from 'common/components/elements/truncate-text';
import { filterBadWords } from 'common/utils/filter-bad-words';
import DateFormatter from 'common/utils/DateFormatter';
import cx from 'classnames';


const MediaCardTitle = ({
   media,
   isAgeVerificationRequired,
   isLoading,
   type,
   contentCardSettings,
}) => {
   const isShowTimestamp = () => {
      return  contentCardSettings?.timestamp && ['video', 'photoset'].includes(type);
   }

   const getDescriptionText = () => {
      let text = `${ DateFormatter.getDate(media.publish_date) }`;
      if(!!media.is_future_publish_enabled){
         text = 'Coming soon';
      }
      return text;
   }
   const title = media?.title || media?.name
   return (
      <div className='flex flex-col'>
         {
            !isLoading && (
               <div className='flex gap-1.5'>
                  {
                     Boolean(media?.is_pinned)  &&
                     <Icon
                        name='pin'
                        color='warning'
                        darkColor='warning-dark'
                        className='h-5 w-5 min-h-[20px] min-w-[16px] rotate-[35deg]'
                        size='xl'
                        data-tooltip-content='Pinned'
                        data-tooltip-id='ams-top-tooltip'
                     />
                  }
                  <TruncateText
                     text={ isAgeVerificationRequired ? filterBadWords(title) : title }
                     textClass='text-xl font-bold text-major leading-6 dark:text-major-dark title dark:shadow-none'
                     textSize='20px'
                     fontWeight='700'
                  />

               </div>
            )
         }
         {
            isLoading && (<div className='loading-card h-6 w-full' />)
         }

         {
            isShowTimestamp() && (
               <>
                  {
                     isLoading && (
                        <div className='loading-card h-4 w-full' />
                     )
                  }
                  {
                     !isLoading && (
                        <span className=' text-placeholder dark:text-placeholder-dark panel-description'>
                           {type === 'video' ? 'Video •' : 'Photoset •'} {getDescriptionText()}
                        </span>
                     )
                  }
               </>
            )
         }

      </div>
   )
}
const MediaTopLables = ({
   media,
   contentCardSettings,
   type,
}) => {
   const showComingSoon = !!media.is_future_publish_enabled;
   const isPreRelease = 'pre_release' === media.stream_status && 'need_to_soon' !== media.stream_state && showComingSoon;

   return (
      <div className='flex w-full top-0 left-0 right-0 gap-2 z-20 absolute px-[10px] pt-[10px]'>
         {
            !isPreRelease && !!media.is_published && (
               <>
                  {
                     media.new && contentCardSettings?.new_label && (
                        <MediaInfoChip
                           text='NEW'
                        />
                     )
                  }
                  {
                     media.is_updated && !media.watched &&  !!contentCardSettings.updated_label && (
                        <MediaInfoChip
                           text='Updated'
                        />
                     )
                  }
               </>
            )
         }
         {
            media.watched &&
            <MediaButton
               iconName='views'
               dataToolTipContent='Seen'
               onClick={ (e) => {
                  e.preventDefault()
               } }
            />
         }

         {
            isPreRelease  &&  ['video', 'photoset'].includes(type) &&
            <MediaLableItem
               iconName='launch'
               text='Prerelease'
               withoutBackground
            />
         }
         {
            ['video', 'photoset'].includes(type) && (
               <div
                  id={ `${ type }_media_chip_${ media.id }` }
                  className='flex gap-2 flex-row-reverse ml-auto'
               >
                  <MediaChip
                     countOrDuration={ type === 'video' ? media.duration : media.photos_count }
                     type={ type }
                     isBlurBackground={ false }
                  />
               </div>
            )
         }
      </div>
   )
}
const MediaComingSoon = ({
   date,
}) => {
   return (
      <div
         style={ {
            // visibility: hideElement ? 'hidden' : '',
         } }
         className='absolute w-full full text-major-dark bg-no-repeat bg-cover inset-0 flex flex-col items-center justify-center mms-media-card-coming-soon-bg z-30'>
         <div className='flex flex-col justify-between z-20'>
            <span className='font-bold coming-soon-text text-center'>Coming soon</span>
            <span className='leading-tight mt-2 text-center'>{date}</span>
         </div>
      </div>
   )
}

const MediaContentButtonOptions = ({
   data,
   goToMediaDetails,
   isAuthUser,
   onClickTip,
   showShare,
   onShare,
   onClickLike,
   onClickLock,
   contentCardSettings,
   stream_state,
   onChangeFavoriteItem,
   collectionType,
}) => {
   const showComment = !!data.comments_count && contentCardSettings?.total_comment_counts && !!data.can_read_comments;
   const showLock = Boolean(data.is_available_pricings && stream_state !== 'free');
   const canLike = Boolean(contentCardSettings?.like && isAuthUser)
   const canShare = Boolean(contentCardSettings?.share && !!showShare)
   const canSendTip = Boolean(contentCardSettings?.tip && isAuthUser)
   const canChangeFavorite = Boolean(isAuthUser)
   return (
      (!data.is_deleted  && (canLike || canShare || canSendTip || canChangeFavorite || showLock || showComment)) &&
         <div
            className='absolute left-0 bottom-0 flex gap-3 justify-between items-center z-40 w-full p-2 pt-3'
         >
            {
               (showLock || showComment) && (
                  <div
                     className='flex gap-3'
                  >
                     {

                        showLock && (
                           <MediaButton
                              iconName='lock'
                              onClick={ (e) => {
                                 e.preventDefault()
                                 e.stopPropagation()
                                 if(data?.is_available_pricings) {
                                    onClickLock()
                                 }
                              } }
                           />
                        )
                     }
                     {
                        showComment &&
                        <MediaButton
                           iconName='comment'
                           onClick={ (e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              goToMediaDetails()
                           } }
                           text={ data.comments_count }
                        />
                     }
                  </div>
               )
            }
            {
               (canLike || canShare || canSendTip || canChangeFavorite)  && (

                  <MediaMemberBottonOptions
                     onChangeFavoriteItem={ onChangeFavoriteItem }
                     isLiked={ data.is_liked }
                     id={ data.id }
                     isFavorite={ data.is_favorite }
                     onClickLike={ data.is_deleted ? null : () => onClickLike() }
                     canLike={ canLike }
                     canShare={ canShare }
                     canSendTip={ canSendTip }
                     canChangeFavorite={ canChangeFavorite }
                     onShare={ onShare }
                     onClickTip={ onClickTip }
                     collectionType={ collectionType }

                  />
               )
            }
         </div>
   )
}


const MediaTitile = ({
   title,
   isMobile,
   total,
   type,
   alignment,
   description,
   showContentCount,
}) => {
   return (
      <div
         className={ cx({
            'flex flex-col flex-1': true,
            'items-center': alignment === 'center',
         }) }
      >
         <div className='flex items-center gap-6'>
            {
               title && (
                  <h1
                     className={ cx({
                        'font-semibold text-major dark:text-major-dark': true,
                        'text-[24px] leading-[32px]': isMobile,
                        'text-[34px] leading-[40px]': !isMobile,
                     }) }
                  >
                     {title}
                  </h1>
               )
            }
            {
               showContentCount && (
                  <span className='text-sm text-secondary font-medium leading-[16px]'>
                     { `${ total || 0 } ${ type }s` }
                  </span>
               )
            }
         </div>
         {
            description && (
               <span
                  dangerouslySetInnerHTML={ {
                     __html: description,
                  } }
                  className='text-sm text-secondary font-medium leading-[16px] ql-editor' />
            )
         }
      </div>

   )
}

MediaComingSoon.propTypes = {
   date: PropTypes.string,
};
MediaTitile.propTypes = {
   total: PropTypes.number,
   isMobile: PropTypes.bool,
   type: PropTypes.string,
   title: PropTypes.string,
   description: PropTypes.string,
   alignment: PropTypes.string,
   showContentCount: PropTypes.bool,
};
MediaTopLables.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   type: PropTypes.string,
};
MediaCardTitle.propTypes = {
   media: PropTypes.object,
   contentCardSettings: PropTypes.object,
   isAgeVerificationRequired: PropTypes.bool,
   isLoading: PropTypes.bool,
   type: PropTypes.string,
};

MediaContentButtonOptions.propTypes = {
   data: PropTypes.object,
   onClickLike: PropTypes.func,
   goToMediaDetails: PropTypes.func,
   isAuthUser: PropTypes.bool,
   showShare: PropTypes.bool,
   onClickTip: PropTypes.func,
   onShare: PropTypes.func,
   onClickLock: PropTypes.func,
   contentCardSettings: PropTypes.object,
   stream_state: PropTypes.string,
   onChangeFavoriteItem: PropTypes.func,
   collectionType: PropTypes.string,
};


export {
   MediaComingSoon,
   MediaCardTitle,
   MediaContentButtonOptions,
   MediaTopLables,
   MediaTitile,
};


